import React, { useEffect, useState } from 'react';
import { NewronUpsell } from '@ecosystem/newron-upsell';
import { ContextManager } from '../../context/manager';
import { Context, Entity, OpenMarketOptions } from '../../types';
import { deepEqual } from '../../tools/object';

export const UpsellWrapper = () => {
  const [cells, setCells] = useState<string[]>([]);
  const [options, setOptions] = useState<OpenMarketOptions[]>([]);

  const contextSubscriber = async (context: Context) => {
    if (!context) {
      setCells([]);
      setOptions([]);
      return;
    }

    const { openMarkets } = await ContextManager.getInstance().getSettings(['openMarkets']);

    const openMarketsOptions = openMarkets.definition.selection.options.map(opt => ({
      value: (opt as Entity).value,
      periods: (opt as Entity).periods,
      countryName: (opt as any).countryName,
      productName: (opt as any).productName,
    }));

    const cells = context.settings.values.cell.map(v => v.value);

    //adding a check to avoid unnecessary re-renders
    setCells(currentCells => {
      if (!deepEqual(currentCells, cells)) {
        return cells;
      }
      return currentCells;
    });
    setOptions(currentOpenMarketsOptions => {
      if (!deepEqual(currentOpenMarketsOptions, openMarketsOptions)) {
        return openMarketsOptions;
      }
      return currentOpenMarketsOptions;
    });
  };

  useEffect(() => {
    ContextManager.getInstance().subscribeToSettingsChanges(contextSubscriber);
    return () => {
      ContextManager.getInstance().unsubscribeFromSettingsChanges(contextSubscriber);
    };
  }, []);

  // if there is no cell or options data, do not render anything
  if (!cells?.length || !options?.length) {
    return null;
  }

  return <NewronUpsell cells={cells} openMarketOptions={options} />;
};
